import { IUser } from '../../common/types/User'
import { Loja } from '../../common/types/Loja'
import { tiposDeSessao } from '../../common/shareds/sharedEvento'
import { TB_POTENCIA, TB_LOJA, TB_SOMAR } from '../../libs/backend/src/models/TABLE_CONSTANTS'
import { IGrauDeSessao } from '../../common/types/Evento'
import { IEvento, ITipoDaSessao } from 'common/types/Evento'
import Irmao, { UserRole } from 'common/types/Irmao'
import { InputPresenca } from 'common/types/Presenca'

export const obterCorDoEvento = (tipo: 'grau' | 'tipo') => (evento: IEvento) => {
	const tipoDaSessao = sessaoPorId[evento.tipoDaSessao.nome] || evento.tipoDaSessao
	
	switch (tipoDaSessao.tipoDaEntidade) {
		case 'potencia':
		case 'somar':
			return tipoDaSessao.cor || 'primary'
		default:
		switch (tipo) {
			case 'grau':
				switch (evento.grauDaSessao) {
					case 'Grau 1': return 'green'
					case 'Grau 2': return 'orange'
					case 'Grau 3': return 'red'
				}
			default:
				return tipoDaSessao.cor || 'secondary'
		}
	}
}

export const obterDescricaoDoEvento = (tipo: 'grau' | 'tipo') => (evento: IEvento, abreviar?: boolean) => {
	const tipoDaSessao = sessaoPorId[evento.tipoDaSessao.nome] || evento.tipoDaSessao

	switch (tipo) {
		case 'grau':
			switch (tipoDaSessao.tipoDaEntidade) {
				case 'loja':
					return abreviar
						? `${(evento.entidade as Loja).abreviacao || evento.entidade.nome}`
						: `${evento.entidade.nome}`
				case 'potencia':
					return evento.entidade.nome
				case 'somar':
					return abreviar
						? tipoDaSessao.abreviacao
						: tipoDaSessao.nome
			}

		default:
			return abreviar
				? tipoDaSessao.abreviacao
				: tipoDaSessao.nome
	}
}

export function obterDescricaoCompletaDoEvento(evento: Omit<IEvento, 'presenca'>) {
	return `${evento.entidade.nome.replace(/\d* ?- ? /, '')}, ${evento.tipoDaSessao.nome}`
}

export const graus: IGrauDeSessao[] = [
	'Grau 1',
	'Grau 2',
	'Grau 3',
]

export const displayEntidade = {
	[TB_LOJA]: 'Loja',
	[TB_POTENCIA]: 'Potência',
	[TB_SOMAR]: 'Somar',
}


export const sessaoPorId = tiposDeSessao.reduce<Record<string, ITipoDaSessao>>((acc, sessao) => {
	return {
		...acc,
		[sessao.nome]: sessao,
	}
}, {})

export const tiposDeSessaoParcial = Object
	.keys(tiposDeSessao
		.reduce<{[key: string]: ITipoDaSessao}>((tipos, tipo) => ({
			[tipo.nome.split(' -')[0]]: tipo,
			[tipo.nome]: tipo,
			...tipos,
		}), {},
	))
	.sort((tipoA, tipoB) => tipoA.localeCompare(tipoB))

export const temGrauParaParticiparDoEvento = (evento: IEvento, irmao: Irmao) => {
	if (!evento.grauDaSessao) return true
	switch (irmao.grauMacon) {
		case 'Aprendiz':
			return ['Grau 1'].includes(evento.grauDaSessao)
		case 'Companheiro':
			return [
				'Grau 1',
				'Grau 2',
			].includes(evento.grauDaSessao)
		case 'Mestre':
		case 'Mestre Instalado':
			return ([
				'Grau 1',
				'Grau 2',
				'Grau 3',
			] as IGrauDeSessao[]).includes(evento.grauDaSessao)
		default:
			return false
	}
}

export const irmaoPodeParticiparDoEventoCasoSejaDeLoja = (evento: IEvento, irmao: IUser) => {	
	const tipoDaSessao = sessaoPorId[evento.tipoDaSessao.nome]  || evento.tipoDaSessao

	if (!tipoDaSessao.exclusivoDeLoja) return true
	if (irmao.role === 'Visitante' || !irmao.configuracaoLimitada) return false
	return [
		irmao.loja,
		...irmao.lojas.map(({ loja }) => loja),
	].some(({ _id }) => _id === evento.entidade._id)
}

export function criarPresenca(presenca: Partial<InputPresenca>): InputPresenca {
	assertTemValor(presenca.evento, 'Evento não informado')
	assertTemValor(presenca.irmao, 'Evento não informado')
	return {
		evento: presenca.evento,
		irmao: presenca.irmao,
		intencoes: [],
		...presenca,
	}
}

export function irmaoPodeVerPresenca(evento: IEvento, irmao: IUser | null) {
	const tipoDaSessao = sessaoPorId[evento.tipoDaSessao.nome]  || evento.tipoDaSessao

	// se não tiver usuário logado ou evento não foi buscado não tem como confirmar presença
	if (!irmao || !evento) return false
	// qualquer irmão pode participar de evento de somar
	if (tipoDaSessao.tipoDaEntidade === 'somar') return true
	// presença pode ser confirmada somente em eventos de loja
	if (tipoDaSessao.tipoDaEntidade !== 'loja') return false
	// se for visitante ele pode confirmar presença de visitante
	if (irmao.role === 'Visitante') return true
	return true
}

export function assertTemValor<T>(valor: T | undefined | null, mensagem = 'Valor está vazio'): asserts valor is T  {
	if (!valor) {
		throw new Error(mensagem)
	}
}

export const PERMISSOES_ADICIONAR_EVENTO: UserRole[] = [ 'admin', 'admin-potencia', 'admin-loja' ]
